export const maskCardNumber = (cardNumber: string | number): string => {
  // Coerce to string and strip non-digit characters
  const numStr =
    cardNumber != null ? String(cardNumber).replace(/\D/g, "") : "";
  if (numStr.length === 0) {
    return "----";
  }
  // Mask all as X if 4 or fewer digits
  if (numStr.length <= 4) {
    return "X".repeat(4);
  }
  const lastFour = numStr.slice(-4);
  const numToMask = numStr.length - 4;
  const maskedPart = "X".repeat(numToMask);
  const groups: string[] = [];
  for (let i = 0; i < maskedPart.length; i += 4) {
    groups.push(maskedPart.substring(i, i + 4));
  }
  return groups.join("-") + "-" + lastFour;
};

export const formatCardNumber = (cardNumber) => {
  return cardNumber.match(/.{1,4}/g).join("-");
};
